export const FETCH_SUCCESS = "FETCH_SUCCESS"
export const FETCH_LOADING = "FETCH_LOADING"
export const FETCH_ERROR = "FETCH_SUCCESS"